import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorScheduleData,
  selectForwardAccumulatorScheduleFieldValidation,
  selectForwardAccumulatorScheduleTable,
  selectForwardAccumulatorSettlementFrequencyData,
} from '@/store/forwardAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/forwardAccumulator/state.ts';
import { useAppSelector } from '@/store/hooks.ts';

const FixingDate = ({ legId }: { legId: string }) => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { settlementFrequency } = useAppSelector((state) =>
    selectForwardAccumulatorSettlementFrequencyData(state, tileId),
  );

  const fixingDate = useAppSelector((state) => selectForwardAccumulatorScheduleTable(state, tileId, legId)?.fixingDate);
  const isModified = useAppSelector(
    (state) =>
      selectForwardAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('FixingDate') ??
      false,
  );

  const { validation } = useAppSelector((state) =>
    selectForwardAccumulatorScheduleFieldValidation(state, tileId, legId, 'fixingDateString'),
  );

  const handleFixingDate = (value: string) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Fixing date changed', value ?? 'null');

    return check({
      schedule: { [legId]: { fixingDate: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: settlementFrequency === 'Maturity' ? '' : '8rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext
          color={isModified ? 'info' : undefined}
          date={isDefined(fixingDate) ? fixingDate : undefined}
          onChange={handleFixingDate}
          allTenors={[]}
          data-e2e="fixingDate"
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default FixingDate;
